'use client'

// libraries
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'

export const useStaggerLeft = () => {
	useGSAP(() => {
		// Find all elements with data-stagger-left attribute
		const staggerContainers = document.querySelectorAll('[data-stagger-left="true"]')
		
		// Set up Intersection Observer
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const container = entry.target
						const children = container.children

						if (children.length > 0) {
							gsap.fromTo(children, 
								{
									transform: 'translateX(100%)',
									opacity: 0
								}, 
								{
									transform: 'translateX(0)',
									opacity: 1,
									duration: 1,
									delay: 0.2,
									stagger: 0.175,
									ease: 'circ.out'
								}
							)
						}

						// Stop observing this container after animation triggers
						observer.unobserve(container)
					}
				})
			},
			{
				threshold: 0.1, // Trigger when 10% of element is visible
				rootMargin: '0px 0px -5% 0px' // Similar to start: '0 95%'
			}
		)

		// Observe all containers
		staggerContainers.forEach(container => {
			// Set initial state
			if (container.children.length > 0) {
				gsap.set(container.children, {
					transform: 'translateX(100%)',
					opacity: 0
				})
			}
			observer.observe(container)
		})

		// Cleanup function
		return () => {
			observer.disconnect()
		}
	})
}
